import localhost from "../../../apis/localhost";
import {
  isNonAdvancingCursor,
  SITE_PROVENANCE,
} from "../../../constants/sharepointAccess";
import { selectAllowedSitesDiscovery } from "../allowedSitesSelectors";
import {
  setDiscoveryError,
  setDiscoveryLoading,
  setDiscoveryLoadMoreError,
  setDiscoverySearchResults,
} from "../allowedSitesSlice";
import { PAGE_SIZE, REQUEST_CONFIG } from "./allowedSitesConstants";
import {
  allowedSitesUrl,
  asSiteRows,
  handleDiscoveryError,
} from "./allowedSitesUtils";

export const searchAvailableSites =
  ({ isCloudMode, append = false, useApplied = false }) =>
  async (dispatch, getState) => {
    const discovery = selectAllowedSitesDiscovery(getState());
    // Continuation and refresh must repeat the query the current results came from, not
    // whatever has since been typed into the box.
    const search =
      append || useApplied ? discovery.appliedSearch : discovery.search.trim();
    if (!search) {
      return;
    }
    const offset = append ? discovery.searchPagination.nextStartRow : "0";
    dispatch(setDiscoveryLoading(true));
    dispatch(setDiscoveryError(null));
    try {
      const { data } = await localhost.get(
        allowedSitesUrl(isCloudMode, "/available-sites/search"),
        { ...REQUEST_CONFIG, params: { search, limit: PAGE_SIZE, offset } }
      );
      const pagination = data?.pagination || {};
      const nonAdvancing = isNonAdvancingCursor(pagination, offset);
      dispatch(
        setDiscoverySearchResults({
          search,
          sites: asSiteRows(data?.results, SITE_PROVENANCE.search),
          pagination: {
            ...pagination,
            hasMore: Boolean(pagination.hasMore) && !nonAdvancing,
          },
          append,
        })
      );
      if (nonAdvancing) {
        dispatch(setDiscoveryLoadMoreError(true));
      }
    } catch (error) {
      handleDiscoveryError(dispatch, error);
    } finally {
      dispatch(setDiscoveryLoading(false));
    }
  };
